export const FEATURE_NAME = '@zerops/zerops/core/transaction-debit-base';
